import { FrontendField } from "../netgen/FrontendField";

export class FrontendFieldValueChangedEvent {

    static simple(field: FrontendField, byUser: boolean): FrontendFieldValueChangedEvent {
        return new FrontendFieldValueChangedEvent(field.id, field.value, null, false, byUser);
    }

    constructor(public fieldId: string, public newValue: any, public oldValue: any, public oldValueKnown: boolean, public byUser: boolean) { 
    }  
}